import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setValidation } from './validation';
import { startFormLoading, stopFormLoading } from './loader';


const fetchedCommonAreaAssetsDone = payload => ({
    type:TYPES.FETCH_COMMON_AREA_ASSETS_DONE,
    payload
})

export const fetchCommonAreaAssets = ( commonAreaId ) => dispatch => {
    return client.fetchCommonAreaAssets( commonAreaId ).then( response => {
        if(response.status === 200 || response.ok){
            response.json().then(
                responsejson => {
                    dispatch(fetchedCommonAreaAssetsDone(responsejson))
                }
            )
        }
    })
}

const onSaveCommonAreaDone = payload => ({
    type:TYPES.SAVE_COMMON_AREA_DONE,
    payload
})

export const saveCommonAreaAsset = params => dispatch => {
    dispatch(startFormLoading())
    return client.saveCommonAreaAsset( params ).then( response => {
        dispatch(stopFormLoading())
        if (response.status === 200 || response.ok) {
            response.json().then(
                responsejson => {
                    if (responsejson.statusCode === 402) {
                        toast.error('🚫 Serial Number already exists please try with other', { autoClose: 12000,position:'top-center' });
                        dispatch(setValidation('Serial Number already exists please try with other'))
                    } else {
                        toast.success('ⓘ Common Area Asset has been added.', { autoClose: 10000,position:'top-center' });
                        dispatch(setValidation('Success'))
                        dispatch(onSaveCommonAreaDone(responsejson.data))
                       
                    }
                }
            )
        }
    })
}

const onUpdateCommonAreaAssetDone = payload => ({
    type:TYPES.UPDATE_COMMON_AREA_DONE,
    payload
})

export const updateCommonAreaAsset = params => dispatch => {
    dispatch(startFormLoading())
    return client.updateCommonAreaAsset( params ).then( response => {
        dispatch(stopFormLoading())
        if( response.status === 200 || response.ok ){
            response.json().then(
                responsejson => {
                    toast.success('ⓘ Common Area Asset has been updated.',{autoClose:10000,position:'top-center'})
                    dispatch(setValidation('Success'))
                    dispatch(onUpdateCommonAreaAssetDone(responsejson.data))
                  
                }
            )
        }   
    })
}

const onDeleteCommonAreaAssetDone = payload => ({
    type:TYPES.DELETE_COMMON_AREA_DONE,
    payload
})

export const deleteCommonAreaAsset = commonAreaAssetId => dispatch => {
    return client.deleteCommonAreaAsset( commonAreaAssetId ).then( response => {
        if( response.status === 200 || response.ok ){
            response.json().then(
                responsejson => {
                    dispatch(onDeleteCommonAreaAssetDone(commonAreaAssetId))
                    toast.success(' ⓘ Common Area Asset has been deleted.',{autoClose: 10000,position:'top-center'})
                }
            )
        }
    })
}
